import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 36,
  height: 36,
}

const Box = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 35.75 35.75'
  >
    <g fill={color}>
      <path d='M35.75,2.306V1.153A1.154,1.154,0,0,0,34.6,0H1.153A1.154,1.154,0,0,0,0,1.153V2.306A1.154,1.154,0,0,0,1.153,3.46V32.4A1.728,1.728,0,0,0,0,34.02v1.73H35.75V34.02A1.727,1.727,0,0,0,34.6,32.4V3.46A1.154,1.154,0,0,0,35.75,2.306ZM1.153,1.153H34.6V2.306H1.153ZM14.992,3.46V32.29H2.306V3.46ZM34.6,34.6H1.153V34.02a.577.577,0,0,1,.577-.577H34.02a.577.577,0,0,1,.577.577ZM33.444,5.766H24.218a1.732,1.732,0,0,0-1.73,1.73v1.73h-.577a1.732,1.732,0,0,0-1.73,1.73v1.73h5.766v-1.73a1.732,1.732,0,0,0-1.73-1.73h-.577V7.5a.577.577,0,0,1,.577-.577h9.226v7.5H31.137V13.262H29.984v3.46h1.153V15.569h2.306V32.29h-17.3V3.46h17.3Zm-9.226,4.613a.577.577,0,0,1,.577.577v.577h-3.46v-.577a.577.577,0,0,1,.577-.577Zm0,0' />
      <path
        d='M147.46,213.766V208H144v5.766Zm-2.306-4.613h1.153v3.46h-1.153Zm0,0'
        transform='translate(-133.621 -193.008)'
      />
      <path d='M312,192h1.153v2.306H312Zm0,0' transform='translate(-289.512 -178.161)' />
      <path d='M312,240h1.153v2.306H312Zm0,0' transform='translate(-289.512 -222.702)' />
      <path d='M312,288h1.153v2.306H312Zm0,0' transform='translate(-289.512 -267.242)' />
      <path
        d='M284.367,193.8l.309-2.286,1.143.154-.309,2.286Zm0,0'
        transform='translate(-263.871 -177.712)'
      />
      <path
        d='M277.938,241.365l.309-2.286,1.143.154-.309,2.286Zm0,0'
        transform='translate(-257.905 -221.846)'
      />
      <path
        d='M271.5,288.934l.309-2.286,1.143.154-.309,2.286Zm0,0'
        transform='translate(-251.931 -265.987)'
      />
      <path
        d='M336.988,191.639l1.146-.128.255,2.293-1.146.128Zm0,0'
        transform='translate(-312.699 -177.708)'
      />
      <path
        d='M342.277,239.353l1.146-.127.255,2.292-1.146.127Zm0,0'
        transform='translate(-317.607 -221.984)'
      />
      <path
        d='M347.574,287.057l1.146-.127.254,2.292-1.146.127Zm0,0'
        transform='translate(-322.522 -266.248)'
      />
    </g>
  </svg>
)

export default Box
